<template>
  <v-form ref="pushNotificationForm" v-model="valid" class="notification-page" @submit.prevent="save()">
    <v-row>
      <v-col cols="12">
        <h1>Уведомления (бонусы)</h1>
        <h5>{NAME} - есть в текст надо вставить имя юзера, {XX} - количество бонусов</h5>

        <v-tabs v-model="tab" class="mt-6">
          <v-tab>Настройки</v-tab>
          <v-tab @click="loadLogs">Лог</v-tab>
          <v-tab>Тест</v-tab>
        </v-tabs>
      </v-col>

      <v-col cols="12" :sm="tab === 1 ? 12 : 8" :md="tab === 1 ? 12 : 6" :xl="tab === 1 ? 12 : 4">
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-text-field
              v-model="notification.title"
              label="Заголовок"
              :rules="[rules.required]"
              outlined
            ></v-text-field>
            <v-textarea
              v-model="notification.text"
              label="Описание"
              :rules="[rules.required]"
              outlined
            ></v-textarea>
            <v-text-field
              type="number"
              v-model="notification.maxPerDay"
              label="Максимальное кол-во юзеров в день"
              :rules="[rules.required]"
              outlined
            ></v-text-field>
            <v-text-field
              type="number"
              v-model="notification.throttlePerUser"
              label="Не повторять чаще чем по одному юзеру (в днях)"
              :rules="[rules.required]"
              outlined
            ></v-text-field>
            <v-text-field
              type="time"
              v-model="notification.sendFrom"
              label="Отправлять с"
              :rules="[rules.required]"
              outlined
            ></v-text-field>
            <v-text-field
              type="time"
              v-model="notification.sendTo"
              label="Отправлять до"
              :rules="[rules.required]"
              outlined
            ></v-text-field>
            <v-checkbox v-model="notification.on" label="Включен"></v-checkbox>
            <v-checkbox v-model="notification.debug" label="Debug режим"></v-checkbox>
            <v-btn type="submit">Отправить</v-btn>
            <div v-if="saved || error" class="mt-3">
              <span class="green--text" v-if="saved">Сохранено успешно</span>
              <span class="red--text" v-if="error">Ошибка сохранения</span>
            </div>
          </v-tab-item>

          <v-tab-item>
            <v-btn type="button" class="mb-4" @click="loadLogs">Обновить</v-btn>
            <div class="mb-4">
              <h3>Заказали меньше 3 дней назад: {{ recentOrderCount }}</h3>
            </div>
            <div class="mb-4">
              <h3>Статистика</h3>
              <div>Всего отправили сообщений: {{ logStats.sent }}</div>
              <div>Есть реакция: {{ logStats.reacted }}</div>
              <div>Конверсия: {{ logStats.conversion }}%</div>
            </div>
            <v-data-table
              :headers="logHeaders"
              :items="logs"
              :server-items-length="logsTotal"
              :options.sync="logOptions"
              :loading="logsLoading"
              :footer-props="logFooterProps"
              no-data-text="Лог пуст"
              @update:options="loadLogs"
            >
              <template v-slot:item.user="{ item }">
                {{ item.user_id || item.phone || '-' }}
              </template>
              <template v-slot:item.created_at="{ item }">
                {{ formatDate(item.created_at) }}
              </template>
              <template v-slot:item.user_last_buy_at="{ item }">
                {{ formatDate(item.user_last_buy_at) }}
              </template>
              <template v-slot:item.has_reaction="{ item }">
                <v-simple-checkbox :value="item.has_reaction" disabled></v-simple-checkbox>
              </template>
              <template v-slot:item.message="{ item }">
                <span style="white-space: pre-line">{{ logMessage(item) }}</span>
              </template>
              <template v-slot:item.log_status="{ item }">
                {{ logStatus(item) }}
              </template>
              <template v-slot:item.log_response="{ item }">
                <span class="text-break">{{ item.log_response || '-' }}</span>
              </template>
            </v-data-table>
          </v-tab-item>

          <v-tab-item>
            <v-autocomplete
              v-model="testUserId"
              :items="testUsers"
              :loading="testUsersLoading"
              :search-input.sync="testUserSearch"
              item-value="id"
              item-text="text"
              label="Пользователь"
              placeholder="Начните вводить email"
              no-data-text="Ничего не найдено"
              clearable
              outlined
            ></v-autocomplete>
            <v-btn type="button" :loading="testLoading" @click="sendTest">Отправить тест</v-btn>
            <div v-if="testResult" class="mt-3" :class="testResult.ok ? 'green--text' : 'red--text'">
              {{ testResultText }}
            </div>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import SettingService from "@/api/SettingService";

export default {
  name: 'PushBonusNotification',
  data: () => ({
    tab: 0,
    notification: {
      id: 0,
      text: '',
      title: '',
      maxPerDay: '',
      throttlePerUser: '',
      sendFrom: '10:00',
      sendTo: '18:00',
      on: false,
      debug: false,
    },
    logs: [],
    recentOrderCount: 0,
    logStats: {
      sent: 0,
      reacted: 0,
      conversion: 0,
    },
    logsTotal: 0,
    logsLoading: false,
    logOptions: {
      page: 1,
      itemsPerPage: 25,
      sortBy: [],
      sortDesc: [],
    },
    logHeaders: [
      {text: 'ID', value: 'id', sortable: false},
      {text: 'Дата', value: 'created_at', sortable: false},
      {text: 'Канал', value: 'channel', sortable: false},
      {text: 'Юзер', value: 'user', sortable: false},
      {text: 'Последний заказ', value: 'user_last_buy_at', sortable: true},
      {text: 'Есть реакция', value: 'has_reaction', sortable: false},
      {text: 'Статус', value: 'log_status', sortable: false},
      {text: 'Ответ', value: 'log_response', sortable: false},
      {text: 'Текст', value: 'message', sortable: false},
    ],
    logFooterProps: {
      itemsPerPageOptions: [10, 25, 50, 100],
      itemsPerPageText: 'Строк на странице:',
      pageText: '{0}-{1} из {2}',
    },
    testUserId: '',
    testUserSearch: '',
    testUsers: [],
    testUsersLoading: false,
    testLoading: false,
    testResult: null,
    rules: {
      required: value => !!value || 'Нужно заполнить',
    },
    saved: false,
    error: false,
    valid: true,
  }),
  computed: {
    testResultText() {
      if (!this.testResult) return '';
      return this.testResult.ok
        ? `Отправлено через ${this.testResult.channel || 'push'}`
        : `Ошибка: ${this.testResult.error || 'не удалось отправить'}`;
    }
  },
  mounted() {
    SettingService.get('push_bonus').then(response => {
      const notData = response.data;

      this.notification = {
        title: 'Давно не бачились!',
        text: 'В тебе на рахунку є {XX} бонусів. Не забудь ними скористатися!',
        on: false,
        debug: false,
        maxPerDay: '500',
        throttlePerUser: '90',
        sendFrom: '10:00',
        sendTo: '18:00',
        id: notData.id,
        ...JSON.parse(notData.value)
      };
    });
  },
  watch: {
    testUserSearch(value) {
      this.searchTestUsers(value);
    }
  },
  methods: {
    searchTestUsers(query) {
      if (!query || query.length < 2) {
        this.testUsers = [];
        return;
      }

      this.testUsersLoading = true;
      SettingService.searchTestUsers(query)
        .then(response => {
          this.testUsers = response.data.users.map(user => ({
            id: user.id,
            text: `${user.email || 'без email'} / ${user.phone || 'без телефона'} / ID ${user.id}`,
          }));
        })
        .finally(() => {
          this.testUsersLoading = false;
        });
    },
    loadLogs() {
      const sortBy = this.logOptions.sortBy && this.logOptions.sortBy[0] === 'user_last_buy_at'
        ? 'last_buy_at'
        : '';

      this.logsLoading = true;
      SettingService.debugLogs('push_bonus', {
        paginated: 1,
        page: this.logOptions.page,
        per_page: this.logOptions.itemsPerPage,
        sort_by: sortBy,
        sort_desc: this.logOptions.sortDesc && this.logOptions.sortDesc[0] ? 'true' : 'false',
      }).then(response => {
        this.logs = response.data.data;
        this.logsTotal = response.data.total;
        this.recentOrderCount = response.data.recent_order_count || 0;
        this.logStats = response.data.stats || {sent: 0, reacted: 0, conversion: 0};
      }).finally(() => {
        this.logsLoading = false;
      });
    },
    logMessage(log) {
      if (log.channel === 'viber') {
        return log.text || '';
      }

      return [log.title, log.text].filter(Boolean).join('\n');
    },
    logStatus(log) {
      if (log.log_status === 'debug') return 'Debug';
      if (log.log_status === 'sent') return 'Отправлено';
      if (log.log_status === 'error') return 'Ошибка';

      return '-';
    },
    formatDate(value) {
      if (!value) return '-';

      const date = new Date(value);

      if (Number.isNaN(date.getTime())) {
        return value;
      }

      return new Intl.DateTimeFormat('uk-UA', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      }).format(date);
    },
    sendTest() {
      this.testResult = null;
      this.testLoading = true;

      SettingService.testSend('push_bonus', this.testUserId)
        .then(response => {
          this.testResult = response.data;
        })
        .catch(error => {
          this.testResult = {
            ok: false,
            error: error.response && error.response.data ? JSON.stringify(error.response.data) : error.message
          };
        })
        .finally(() => {
          this.testLoading = false;
        });
    },
    save() {
      this.$refs.pushNotificationForm.validate();
      this.saved = false;
      this.error = false;

      if (this.valid) {
        SettingService.update(this.notification.id, {value: this.notification}).then(() => {
          this.saved = true;
        }).catch(error => {
          console.error(error);
          this.error = true;
        });
      }
    }
  }
}
</script>

<style scoped lang="scss">
.notification-page {
  padding-bottom: 32px;
}
</style>
